<template>
    <v-container fluid style="margin: 60px 10%">
        <vueHeadful
        :title="this.$i18n.t('Menu.AdministracionUsuarios') + ' - TrArtist'"
        :url="'https://trartist.com' + $route.fullPath"
        />
        <v-row>
            <v-col cols="12" align="center">
                <v-btn @click="eleccion = 'artistas'" outlined class="ma-2" style="border: 2px solid;">Artistas</v-btn>
                <v-btn @click="eleccion = 'clientes'" outlined class="ma-2" style="border: 2px solid;">Clientes</v-btn>
            </v-col>
            <v-col cols="12" class="pb-0 mb-0">
              <v-text-field v-model="buscar" solo :label="$t('Busqueda.Buscar')" :hint="$t('Busqueda.Buscar')" />
            </v-col>
            <v-col cols="12" class="pt-0 mb-0" align="center" v-if="eleccion === 'artistas'">
                <v-data-table
                :headers="headerArtistas"
                :items="artistas"
                :search="buscar">
                <template v-slot:[`item.foto`]="{ item }">
                    <v-avatar class="ma-1"><v-img :src="item.fotoPerfil" /></v-avatar>
                </template>
                <template v-slot:[`item.aprobado`]="{ item }">
                  <v-icon color="green" v-if="item.aprobado && !item.revision">fas fa-check</v-icon>
                  <v-icon color="red" v-if="!item.aprobado && !item.revision">fas fa-times</v-icon>
                  <v-icon v-if="item.revision">far fa-clock</v-icon>
                </template>
                <template v-slot:[`item.ver`]="{ item }">
                    <v-btn icon @click="abrirDialog(item, 'artista')"><v-icon color="black">far fa-eye</v-icon></v-btn>
                </template>
                <template v-slot:[`item.pais`]="{ item }">
                    <span>{{getPaises[item.pais - 1].name}}</span>
                </template>
                </v-data-table>
                <v-btn @click="exportCSVFile()" color="primary white--text" x-large>Exportar</v-btn>
            </v-col>
            <v-col cols="12" class="pt-0 mb-0" v-else>
                <v-data-table
                :headers="headerClientes"
                :items="clientes"
                :search="buscar">
                <template v-slot:[`item.pais`]="{ item }">
                    <span v-if="item.pais">{{getPaises[item.pais - 1].name}}, {{item.departamento}}, {{item.ciudad}}</span>
                </template>
                <template v-slot:[`item.ver`]="{ item }">
                    <v-btn icon @click="abrirDialog(item, 'cliente')"><v-icon color="black">far fa-eye</v-icon></v-btn>
                </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog">
          <v-card v-if="usuarioElegido">
            <v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="12" align="center" class="mb-5 pb-5">
                    <h1>{{$t('Carrito.Informacion')}}</h1>
                  </v-col>
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                    <v-avatar size="70"><v-img :src="usuarioElegido.fotoPerfil" /></v-avatar>
                  </v-col>
                  <v-col cols="12" align="center">
                    <h2>{{usuarioElegido.nombre}}</h2>
                    <h3 v-if="usuarioElegido.rol === 'artista'">({{usuarioElegido.pseudonimo}})</h3>
                  </v-col>
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                    <span class="font-weight-bold">{{$t('Busqueda.Categoria')}}</span>
                    <br>
                    <span>{{usuarioElegido.categoria}}</span>
                  </v-col>
                  <v-col cols="12" align="center">
                    <span>{{ getPaises[usuarioElegido.pais - 1].name }} - {{ usuarioElegido.departamento }} - {{ usuarioElegido.ciudad }}</span>
                  </v-col>
                  <v-col cols="12" align="center">
                    <span class="font-weight-bold">Newsletter</span>
                    <br>
                    <v-icon color="green" v-if="usuarioElegido.newsletter">fas fa-check</v-icon>
                    <v-icon color="red" v-else>fas fa-times</v-icon>
                  </v-col>
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                    <v-text-field solo v-model="usuarioElegido.nombreDeUsuario" readonly :label="$t('Formularios.Usuario')" :hint="$t('Formularios.HintUsuario')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-text-field solo v-model="usuarioElegido.email" readonly :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-text-field solo v-model="usuarioElegido.tipoDocumento" readonly :label="$t('Pago.TipoDocumento')" :hint="$t('Pago.TipoDocumento')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-text-field solo v-model="usuarioElegido.numeroDocumento" readonly :label="$t('Pago.NumeroDocumento')" :hint="$t('Pago.NumeroDocumento')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-text-field solo v-model="usuarioElegido.telefono" readonly :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-text-field solo v-model="usuarioElegido.direccion" readonly :label="$t('Formularios.Direccion')" :hint="$t('Formularios.Direccion')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-text-field solo v-model="usuarioElegido.codigoPostal" readonly :label="$t('Formularios.CodigoPostal')" :hint="$t('Formularios.CodigoPostal')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-text-field solo v-model="usuarioElegido.medioDePago" readonly :label="$t('Formularios.MedioDePago')" :hint="$t('Formularios.MedioDePago')" persistent-hint />
                  </v-col>
                  <!-- VIDEO YOUTUBE -->
                  <v-col align="center" cols="12" xs="12" md="12" v-if="usuarioElegido.rol === 'artista'">
                    <iframe :style="marginVideo" width="50%" :height="videoHeight" :src="`https://www.youtube.com/embed/${usuarioElegido.videoYoutube}`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </v-col>
                   <!-- REFERENCIAS PERSONALES -->
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                      <h2 style="word-break:break-word;">{{$t('Menu.ReferenciaPersonal')}}</h2>
                  </v-col>
                  <!-- NOMBRE REF PERSONAL -->
                  <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuarioElegido.rol === 'artista'">
                      <v-text-field solo v-model="usuarioElegido.nombreRefPersonal" :label="$t('Formularios.NombreCompleto')" :hint="$t('Formularios.NombreCompleto')" persistent-hint/>
                  </v-col>
                  <!-- Email REF PERSONAL -->
                  <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuarioElegido.rol === 'artista'">
                      <v-text-field solo v-model="usuarioElegido.emailRefPersonal" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" persistent-hint/>
                  </v-col>
                  <!-- TELEFONO REF PERSONAL -->
                  <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuarioElegido.rol === 'artista'">
                      <v-text-field solo v-model="usuarioElegido.telefonoRefPersonal" :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')" persistent-hint/>
                  </v-col>
                   <!-- REFERENCIAS PROFESIONALES-->
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                      <h2 style="word-break:break-word;">{{$t('Menu.ReferenciaProfesional')}}</h2>
                  </v-col>
                  <!-- NOMBRE REF PROFESIONAL -->
                  <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuarioElegido.rol === 'artista'">
                      <v-text-field solo v-model="usuarioElegido.nombreRefProfesional" :label="$t('Formularios.NombreCompleto')" :hint="$t('Formularios.NombreCompleto')" persistent-hint/>
                  </v-col>
                  <!-- Email REF PROFESIONAL -->
                  <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuarioElegido.rol === 'artista'">
                      <v-text-field solo v-model="usuarioElegido.emailRefProfesional" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" persistent-hint/>
                  </v-col>
                  <!-- TELEFONO REF PROFESIONAL -->
                  <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuarioElegido.rol === 'artista'">
                      <v-text-field solo v-model="usuarioElegido.telefonoRefProfesional" :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')" persistent-hint/>
                  </v-col>
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                    <v-textarea solo readonly v-model="usuarioElegido.biografiaEs" :label="$t('Formularios.BiografiaEs')" :hint="$t('Formularios.BiografiaEs')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                    <v-textarea solo readonly v-model="usuarioElegido.biografiaEn" :label="$t('Formularios.BiografiaEn')" :hint="$t('Formularios.BiografiaEn')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                    <a
                    v-for="(redes, index) in usuarioElegido.redesSociales"
                    :key="index"
                    :href="redes.enlace"
                    target="_blank"
                    style="text-decoration:none;"
                    class="mx-5">
                      <v-icon class="ma-2" size="40" color="primary">{{redes.icono}}</v-icon>
                    </a>
                  </v-col>
                  <v-col cols="12" align="center" v-if="usuarioElegido.rol === 'artista'">
                    <hr><br>
                    <v-textarea solo v-model="comentario" :label="$t('Formularios.ComentarioDelModerador')" :hint="$t('Formularios.ComentarioDelModerador')" persistent-hint />
                  </v-col>
                  <v-col cols="12" align="center">
                    <v-btn :loading="getCargandoAccion" outlined class="ma-4" style="border: 2px solid" large @click="dialog = false">{{$t('Formularios.Cerrar')}}</v-btn>
                    <v-btn v-if="usuarioElegido.rol === 'artista'" :loading="getCargandoAccion" class="ma-4" color="black white--text" large @click="rechazar()">{{$t('Administracion.Rechazar')}}</v-btn>
                    <v-btn v-if="usuarioElegido.rol === 'artista'" :loading="getCargandoAccion" color="black white--text" class="ma-4" large @click="aprobar()">{{$t('Administracion.Aprobar')}}</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'AdministracionUsuarios',
  data () {
    return {
      dialog: false,
      usuarioElegido: null,
      indexUsuario: null,
      buscar: null,
      eleccion: null,
      artistas: [],
      clientes: [],
      headerArtistas: [
        { text: 'Foto de Perfil', value: 'foto' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Categoria', value: 'categoria' },
        { text: 'Email', value: 'email' },
        { text: 'Pais', value: 'pais' },
        { text: 'Telefono', value: 'telefono' },
        { text: 'Aprobado', value: 'aprobado' },
        { text: 'Ver', value: 'ver' }
      ],
      headerCSV: {
        nombre: 'Nombre',
        categoria: 'Categoría',
        email: 'Email',
        telefono: 'Telefono',
        aprobado: 'Aprobado'
      },
      headerClientes: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Email', value: 'email' },
        { text: 'Pais', value: 'pais' },
        { text: 'Telefono', value: 'telefono' },
        { text: 'Ver', value: 'ver' }
      ],
      comentario: null
    }
  },
  computed: {
    ...mapGetters(['getPaises', 'getCargandoAccion']),
    videoHeight () {
      if (this.$vuetify.breakpoint.name === 'xl') {
        return '550px'
      } else {
        return '400px'
      }
    },
    marginVideo () {
      if (this.$vuetify.breakpoint.name !== 'xs' && this.$vuetify.breakpoint.name !== 'sm') {
        return 'margin-left: 15px'
      } else {
        return 'margin-left: 0px'
      }
    }
  },
  methods: {
    ...mapMutations(['setCargandoAccion', 'setAlerta', 'setTextoAlerta']),
    ...mapActions(['enviarCorreo']),
    abrirDialog (item, tipo) {
      this.dialog = true
      this.usuarioElegido = item
      if (tipo === 'artista') {
        this.indexUsuario = this.artistas.indexOf(item)
      }
    },
    aprobar () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('usuarios').doc(this.usuarioElegido.uid).update({
        aprobado: true,
        revision: false
      })
        .then(() => {
          this.enviarCorreo({
            email: 'TrArtist <soycliente@trartist.com>',
            destino: this.usuarioElegido.email,
            asunto: this.$i18n.t('Formularios.AsuntoAprobadoArtista'),
            texto: this.$i18n.t('Formularios.MensajeAprobadoArtista', { nombre: this.usuarioElegido.nombre, comentario: this.comentario })
          })
          this.artistas[this.indexUsuario].aprobado = true
          this.artistas[this.indexUsuario].revision = false
          this.setCargandoAccion(false)
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
          this.dialog = false
        })
    },
    rechazar () {
      this.setCargandoAccion(true)
      firebase.firestore().collection('usuarios').doc(this.usuarioElegido.uid).update({
        aprobado: false,
        revision: false
      })
        .then(() => {
          this.enviarCorreo({
            email: 'TrArtist <soycliente@trartist.com>',
            destino: this.usuarioElegido.email,
            asunto: this.$i18n.t('Formularios.AsuntoRechazadoArtista'),
            texto: this.$i18n.t('Formularios.MensajeRechazadoArtista', { nombre: this.usuarioElegido.nombre, comentario: this.comentario })
          })
          this.artistas[this.indexUsuario].aprobado = false
          this.artistas[this.indexUsuario].revision = false
          this.setCargandoAccion(false)
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
          this.dialog = false
        })
    },
    convertToCSV (objArray) {
      let newArray = []
      for (let i = 0; i < objArray.length; i++) {
        newArray.push({
          nombre: objArray[i].nombre,
          categoria: objArray[i].categoria,
          email: objArray[i].email,
          telefono: objArray[i].telefono,
          aprobado: objArray[i].aprobado
        })
      }
      const array = typeof newArray !== 'object' ? JSON.parse(newArray) : newArray
      let str = ''
      for (let i = 0; i < array.length; i++) {
        let line = ''
        for (let index in array[i]) {
          if (line !== '') line += ','
          line += array[i][index]
        }
        str += line + '\r\n'
      }
      return str
    },
    exportCSVFile () {
      this.artistas.unshift(this.headerCSV)
      const csv = this.convertToCSV(this.artistas)
      const exportName = 'artistas.csv'
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', exportName)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    }
  },
  watch: {
    eleccion: function (nuevo, anterior) {
      if (nuevo === 'artistas') {
        if (!this.artistas[0]) {
          firebase.firestore().collection('usuarios').where('rol', '==', 'artista').get().then(info => {
            for (let i = 0; i < info.docs.length; i++) {
              this.artistas.push(info.docs[i].data())
            }
          })
        }
      }
      if (nuevo === 'clientes') {
        if (!this.clientes[0]) {
          firebase.firestore().collection('usuarios').where('rol', '==', 'cliente').get().then(info => {
            for (let i = 0; i < info.docs.length; i++) {
              this.clientes.push(info.docs[i].data())
            }
          })
        }
      }
    }
  }
}
</script>
